package team.platforma.multiplatform_material_extension.ui.core

import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Text
import androidx.compose.material3.TextFieldColors
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Shape
import org.jetbrains.compose.resources.DrawableResource

class InputFieldProperties(
    var modifier: Modifier? = null,
    var label: @Composable (() -> Unit)? = null,
    var endIcon: DrawableResource? = null,
    var keyboardOptions: KeyboardOptions? = null,
    val colors: TextFieldColors? = null,
    var placeholder: @Composable (() -> Unit)? = null,
    var shape: Shape? = null
    ) {
    @Composable
    fun simpleLabel(string: String): InputFieldProperties {
        if (label == null) {
            label = {
                Text(
                    text = string
                )
            }
        }
        return this
    }
    @Composable
    fun simplePlaceholder(string: String): InputFieldProperties {
        if (placeholder == null) {
            placeholder = {
                Text(
                    text = string
                )
            }
        }
        return this
    }
}

